export type ThemePreference = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'pf-theme-preference';

export function resolveTheme(preference: ThemePreference, systemDark: boolean): ResolvedTheme {
  if (preference === 'system') {
    return systemDark ? 'dark' : 'light';
  }
  return preference;
}

export function parseThemePreference(raw: string | null): ThemePreference {
  if (raw === 'dark' || raw === 'light' || raw === 'system') {
    return raw;
  }
  return 'light';
}
